import React from 'react';
import { fmtDate } from '../api';

const money = (v) => (v == null ? '—' : `${Number(v).toLocaleString('it-IT', { maximumFractionDigits: 2 })} €`);
const names = (ps) => (ps || []).map((p) => p.denominazione || `${p.cognome || ''} ${p.nome || ''}`.trim()).filter(Boolean).join(', ') || '—';

const SECTIONS = [
  ['Protesti', ['Data levata', 'Tipo effetto', 'Importo', 'Comune', 'Stato'],
    (d) => (d.protesti || []).flatMap((p) => (p.effetti || []).map((e) => [fmtDate(e.data_levata), e.tipo_effetto, money(e.importo), e.comune_levata, e.stato_effetto || e.motivo_rifiuto_pagamento]))],
  ['Pregiudizievoli di Conservatoria', ['Data', 'Atto', 'Conservatoria', 'Importo', 'A favore di', 'Stato'],
    (d) => (d.pregiudizievoli || []).map((x) => [fmtDate(x.data_registrazione), x.pregiudizievole, x.conservatoria, money(x.importo_iscritto), names(x.favore), x.cancellata ? 'Cancellata' : 'Attiva'])],
  ['Procedure concorsuali', ['Data', 'Procedura', 'Impresa', 'Tribunale', 'Sentenza'],
    (d) => (d.procedure || []).map((x) => [fmtDate(x.data_provvedimento), x.descrizione_procedura, x.denominazione, x.tribunale, x.riferimento_sentenza])],
];

export default function NegativeDetails({ d, id }) {
  return (
    <div className="mt-5 space-y-5" data-testid={`negative-details-${id}`}>
      {SECTIONS.map(([title, head, rows], i) => {
        const data = rows(d);
        return (
          <div key={title} data-testid={`negative-details-${id}-section-${i}`}>
            <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-2">{title} · {data.length}</p>
            {!data.length ? <p className="text-xs text-[#5A5F67]">Nessun elemento.</p> : (
              <div className="overflow-x-auto border border-[#1F242C]">
                <table className="w-full text-xs min-w-[560px]">
                  <thead><tr className="text-left text-[#5A5F67]">{head.map((h) => <th key={h} className="px-3 py-2 font-normal">{h}</th>)}</tr></thead>
                  <tbody>{data.map((r, j) => <tr key={j} className="border-t border-[#1F242C] text-[#C9CCD1]">{r.map((c, k) => <td key={k} className="px-3 py-2">{c || '—'}</td>)}</tr>)}</tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
